/** Resolve ISO 4217 narrow symbol for a currency code (e.g. GBP → £). */
export function getCurrencyNarrowSymbol(
  currencyCode: string | undefined | null,
  localeForIntl: string
): string | undefined {
  const code = currencyCode?.trim();
  if (!code) return undefined;
  const upper = code.toUpperCase();
  if (upper.length !== 3) return undefined;
  try {
    const parts = new Intl.NumberFormat(localeForIntl, {
      style: 'currency',
      currency: upper,
      currencyDisplay: 'narrowSymbol',
    }).formatToParts(0);
    return parts.find((p) => p.type === 'currency')?.value?.trim() || undefined;
  } catch {
    return undefined;
  }
}

/** Prefix already locale-formatted amount with currency symbol (e.g. £ 1,234.56). */
export function formatFormattedAmountWithCurrency(
  currencyCode: string | undefined | null,
  localeForIntl: string,
  formattedNumber: string
): string {
  const symbol = getCurrencyNarrowSymbol(currencyCode, localeForIntl);
  if (symbol) return `${symbol} ${formattedNumber}`;
  const code = currencyCode?.trim();
  if (code) return `${code.toUpperCase()} ${formattedNumber}`;
  return formattedNumber;
}
